import type { ProfileSkill } from 'store/modules/profile_skills'
import type { TProfileSkillOption } from './profile-skill-select.types'

export class ProfileSkillSelectVm {
  constructor(
    private profileSkills: ProfileSkill[],
    private defaultProfileSkillIds?: string[]
  ) {}

  get options(): TProfileSkillOption[] {
    return this.profileSkills.map((profileSkill) => ({
      label: profileSkill.name,
      value: profileSkill.id,
    }))
  }

  get defaultValue(): readonly TProfileSkillOption[] | null {
    if (
      !this.defaultProfileSkillIds ||
      this.defaultProfileSkillIds.length === 0
    ) {
      return null
    }

    return this.options.filter((option) =>
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.defaultProfileSkillIds!.includes(option.value)
    )
  }
}
